export const API_ERROR_LABELS = Object.freeze({
  badRequest: "Request could not be completed. Please check and try again.",
  unauthorized: "Your session is no longer valid. Please sign in again.",
  forbidden: "You do not have permission to do that.",
  notFound: "The requested resource was not found.",
  conflict: "This change conflicts with the current data. Please refresh and try again.",
  tooManyRequests: "Too many requests. Please wait a moment and try again.",
  serverError: "Something went wrong on our side. Please try again.",
  networkError: "Network error. Check your connection and try again.",
  unknownError: "Something went wrong. Please try again.",
});
